<div class="py-4 container-fluid departments-page">
  <h4 class="mb-4 departments-title">การตั้งค่า - สาขาวิชา</h4>

  <div class="departments-card">
    <div class="departments-card-body">
      <div class="departments-toolbar" [formGroup]="form">
        <div class="departments-filter">
          <app-filter-search-input
            label="สาขาวิชา"
            formControlName="keyword"
            inputClass="departments-search-input"
            classes="mb-0"
            ariaLabel="ค้นหาสาขาวิชา"
            (searchSubmit)="onSearch()"
          ></app-filter-search-input>
        </div>
      </div>

      <ng-template #rowIndexTemplate let-row="row" let-rowIndex="rowIndex">
        {{ row.sequence ?? departments().offset + rowIndex + 1 }}
      </ng-template>

      <app-datatable
        [datasource]="departments()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="50"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="departments().page"
        [limit]="departments().limit"
        [total]="departments().total"
        [totalPage]="departments().total_page"
        [offset]="departments().offset"
        [dataLength]="departments().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="Departments pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>
